// @flow

export { logger, LOGGING_COOKIE_NAME } from './logger'
export { getStorage, setItem, getItem, removeItem } from './storage'
export { getQuery, getQueryFallback } from './url'
export { delay } from './delay'
export { loadPolyfillsIfNeeded } from './polyfillLoader'

export const tryParse = (jsonString: string, valueIfError: Object): any => {
  try {
    return JSON.parse(jsonString)
  } catch (error) {
    return valueIfError
  }
}
